<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 480.4 231.5" style="enable-background:new 0 0 480.4 231.5;" xml:space="preserve">
  <g>
    <defs>
      <rect id="t7_1_" y="69.7" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_2_">
      <use xlink:href="#t7_1_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st0">
      <g>
        <defs>
          <path id="t7_3_" d="M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"/>
        </defs>
        <clipPath id="t7_4_">
          <use xlink:href="#t7_3_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st1">
          <path class="st2" d="M0,161.8V69.7h92.2v92.2H0z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_5_" x="335" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_6_">
      <use xlink:href="#t7_5_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st3">
      <g>
        <defs>
          <path id="t7_7_" d="M335,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H344C339,92.2,335,88.1,335,83.2z"/>
        </defs>
        <clipPath id="t7_8_">
          <use xlink:href="#t7_7_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st4">
          <path class="st2" d="M335,92.2V0h92.2v92.2H335z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_9_" x="199.9" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_10_">
      <use xlink:href="#t7_9_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st5">
      <g>
        <defs>
          <path id="t7_11_" d="M199.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C203.9,92.2,199.9,88.1,199.9,83.2z"
            />
        </defs>
        <clipPath id="t7_12_">
          <use xlink:href="#t7_11_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st6">
          <path class="st2" d="M199.9,92.2V0h92.2v92.2H199.9z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_13_" x="73.2" y="69.7" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_14_">
      <use xlink:href="#t7_13_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st7">
      <g>
        <defs>
          <path id="t7_15_" d="M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8
            z"/>
        </defs>
        <clipPath id="t7_16_">
          <use xlink:href="#t7_15_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st8">
          <path class="st2" d="M73.2,161.8V69.7h92.2v92.2H73.2z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_17_" x="69.7" y="0" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_18_">
      <use xlink:href="#t7_17_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st9">
      <g>
        <defs>
          <path id="t7_19_" d="M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"/>
        </defs>
        <clipPath id="t7_20_">
          <use xlink:href="#t7_19_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st10">
          <path class="st2" d="M69.7,0h92.2v92.2H69.7V0z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_21_" x="69.7" y="139.4" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_22_">
      <use xlink:href="#t7_21_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st11">
      <g>
        <defs>
          <path id="t7_23_" d="M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2
            C69.7,143.4,73.7,139.4,78.7,139.4z"/>
        </defs>
        <clipPath id="t7_24_">
          <use xlink:href="#t7_23_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st12">
          <path class="st2" d="M69.7,139.4h92.2v92.2H69.7V139.4z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_25_" x="199.9" y="139.4" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_26_">
      <use xlink:href="#t7_25_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st13">
      <g>
        <defs>
          <path id="t7_27_" d="M208.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2
            C199.9,143.4,203.9,139.4,208.9,139.4z"/>
        </defs>
        <clipPath id="t7_28_">
          <use xlink:href="#t7_27_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st14">
          <path class="st2" d="M199.9,139.4h92.2v92.2h-92.2V139.4z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_29_" x="335" y="139.4" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="t7_30_">
      <use xlink:href="#t7_29_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st15">
      <g>
        <defs>
          <path id="t7_31_" d="M335,222.5v-74.2c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H344C339,231.5,335,227.5,335,222.5z"/>
        </defs>
        <clipPath id="t7_32_">
          <use xlink:href="#t7_31_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st16">
          <path class="st2" d="M335,231.5v-92.2h92.2v92.2H335z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_33_" x="16.3" y="16.3" width="464.1" height="199"/>
    </defs>
    <clipPath id="t7_34_">
      <use xlink:href="#t7_33_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st17">
      <g>
        <defs>
          <path id="t7_35_" d="M39.3,16.3h417.9c6.1,0,11.9,2.4,16.3,6.7c4.3,4.3,6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3
            c-4.3,4.3-10.2,6.7-16.3,6.7H39.3c-6.1,0-12-2.4-16.3-6.7s-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-11.9,6.7-16.3S33.2,16.3,39.3,16.3
            z"/>
        </defs>
        <clipPath id="t7_36_">
          <use xlink:href="#t7_35_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st18">
          <path class="st19" d="M16.3,16.3h464.1v199H16.3V16.3z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="t7_37_" x="172.5" y="40.1" width="151.4" height="151.4"/>
    </defs>
    <clipPath id="t7_38_">
      <use xlink:href="#t7_37_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st20">
      <g>
        <defs>
          <circle id="t7_39_" cx="248.2" cy="115.8" r="75.7"/>
        </defs>
        <clipPath id="t7_40_">
          <use xlink:href="#t7_39_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st21">
          <path class="st2" d="M172.5,40.1h151.4v151.4H172.5V40.1z"/>
        </g>
      </g>
    </g>
  </g>
  </svg>
</template>
<script>
export default {
  name: 't7'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#t7_2_);}
  .st1{clip-path:url(#t7_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t7_6_);}
  .st4{clip-path:url(#t7_8_);}
  .st5{clip-path:url(#t7_10_);}
  .st6{clip-path:url(#t7_12_);}
  .st7{clip-path:url(#t7_14_);}
  .st8{clip-path:url(#t7_16_);}
  .st9{clip-path:url(#t7_18_);}
  .st10{clip-path:url(#t7_20_);}
  .st11{clip-path:url(#t7_22_);}
  .st12{clip-path:url(#t7_24_);}
  .st13{clip-path:url(#t7_26_);}
  .st14{clip-path:url(#t7_28_);}
  .st15{clip-path:url(#t7_30_);}
  .st16{clip-path:url(#t7_32_);}
  .st17{clip-path:url(#t7_34_);}
  .st18{clip-path:url(#t7_36_);}
  .st19{fill:#85B0F9;}
  .st20{clip-path:url(#t7_38_);}
  .st21{clip-path:url(#t7_40_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t7.vue